import { BehaviorSubject } from 'rxjs';
import { IMenu } from './models/core/menu';

export const menu$ = new BehaviorSubject<IMenu[]>([
  {
    route: "home",
    name: "Home",
    type: "link",
    icon: "home"
  },
  {
    route: "lab-user-menu",
    name: "Login",
    type: "link",
    icon: "domain"
  },
  {
    route: "searchLabs",
    name: "Search Labs",
    type: "link",
    icon: "search"
  },
  {
    route: "analytes",
    name: "Search Analytes",
    type: "link",
    icon: "bubble_chart"
  },
  {
    route: "contact",
    name: "Contact",
    type: "link",
    icon: "contact_mail"
  }
]);
